import { z } from 'zod';

export const zeroXSubmissionErrorSchema = z.object({
  version: z.literal(1),
  code: z.enum([
    'ZERO_X_PROCESSING_CONFIGURATION',
    'ZERO_X_PROCESSING_CREDENTIALS_INVALID',
    'ZERO_X_PROCESSING_CREDENTIALS_NOT_FOUND',
    'ZERO_X_PROCESSING_CREDENTIALS_UNAVAILABLE',
    'ZERO_X_PROCESSING_RESPONSE',
    'ZERO_X_PROCESSING_RESPONSE_FORMAT',
    'ZERO_X_PROCESSING_SERIALIZATION',
    'ZERO_X_PROCESSING_TIMEOUT',
    'ZERO_X_PROCESSING_TRANSPORT',
    'WITHDRAWAL_UNCLASSIFIED_ERROR',
  ]),
  httpStatus: z.number().int().min(100).max(599).nullable(),
  observedAt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/)
    .refine((value) => {
      const timestamp = Date.parse(value);
      return Number.isFinite(timestamp) && new Date(timestamp).toISOString() === value;
    }),
  providerCode: z
    .string()
    .max(48)
    .regex(/^(?:\d{1,6}|[A-Z]{1,5}\d{1,6}|[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+)$/)
    .optional(),
});
export type ZeroXSubmissionError = z.infer<typeof zeroXSubmissionErrorSchema>;
